import { msg } from "@lingui/core/macro";
import { Trans, useLingui } from "@lingui/react/macro";

import type { components } from "@/shared/api";
import type { Severity } from "@/shared/ui/severity-dot";

import { SummaryTile } from "./SummaryTile";
import { WEAK_SPOT_LABELS } from "./WEAK_SPOT_LABELS";

type WeakSpot = components["schemas"]["WeakSpotOut"];

const IN_MATCHES = msg({
  message:
    "In {weak} of the last {matches, plural, one {# match} other {# matches}} it was below the rank norm",
});

// Доля матчей, где сторона проседала: от 40% — плохо, от 20% — можно лучше.
const severityOf = ({ weak_matches: weak, matches }: WeakSpot): Severity => {
  const share = weak / matches;
  return share >= 0.4 ? "bad" : share >= 0.2 ? "warn" : "good";
};

// Плитка «Повторяющаяся ошибка»: самая слабая сторона игры по быстрому разбору последних матчей.
export const WeakSpotTile = ({ weakSpot }: { weakSpot: WeakSpot }) => {
  const { i18n } = useLingui();
  return (
    <SummaryTile
      severity={severityOf(weakSpot)}
      label={<Trans>Recurring mistake</Trans>}
      value={i18n._(WEAK_SPOT_LABELS[weakSpot.axis])}
      details={i18n._({
        ...IN_MATCHES,
        values: { weak: weakSpot.weak_matches, matches: weakSpot.matches },
      })}
    />
  );
};
